import { useMediaQuery, useTheme } from "@mui/material";
const useTheme_useTheme = ()=>{
    const materialTheme = useTheme();
    return {
        theme: materialTheme
    };
};
const useIsDarkMode = ()=>'dark' === useTheme_useTheme().theme.palette.mode;
const usePrefersDarkModeMediaQuery = ()=>useMediaQuery('(prefers-color-scheme: dark)');
export { useIsDarkMode, usePrefersDarkModeMediaQuery, useTheme_useTheme as useTheme };

//# sourceMappingURL=useTheme.js.map